import { logger } from '@garnish/logger';

// ─────────────────────────────────────────────────────────────────────────────

logger.enable('OTA');

export const otaLogger = logger.extend('OTA');
